import React from 'react';
import CustomCard from '../../../../components/CustomCard';
import { EmailSubsectionChip, PhoneLight } from '../../../../components/buttons/IconButtons';
import { ArrowRightIcon } from '@mui/x-date-pickers';
import GeneralStepBody from "./GeneralStepBody";
import { STEP_MODEL } from "../../Model/HomeModel";

const VerifyIdentity = ({ t, onSelectFlow }) => {

    const options = [
        {
            title: 'email_otp',
            description: 'email_otp_description',
            icon: <EmailSubsectionChip className='btn-icon-svg-24px' />,
            background: 'background-warning-100',
            flow: STEP_MODEL.EMAIL
        },
        {
            title: 'app_code',
            description: 'app_code_description',
            icon: <PhoneLight className='btn-icon-svg-24px' />,
            background: 'background-primary-100',
            flow: STEP_MODEL.APP
        }
    ];

    return (
        <GeneralStepBody t={t} title='verify_your_identity' description='verify_identity_description'>
            <div className='d-flex flex-column gap-3 mt-3'>
                {options.map((option, index) => (
                    <CustomCard click={() => onSelectFlow(option.flow)} classes={"border-0"} key={index}
                                classContent={'background-shades-50 border-full-shades-400 border-radius-8px p-3'} >
                        <div className='d-flex justify-content-between align-items-center w-100'>
                            <div className='d-flex align-items-center'>
                                <div className={`p-8px border-radius-8px d-flex justify-content-center
                                        align-items-center w-44px h-44px me-3 ${option.background}`}>
                                    {option.icon}
                                </div>
                                <div className='text-start'>
                                    <p className='fs-16px ibl-font-w-600 font-color-general-950 mb-0'>
                                        {t(option.title)}
                                    </p>
                                    <p className='fs-14px font-color-shades-700 ibl-font-w-400 mb-0'>
                                        {t(option.description)}
                                    </p>
                                </div>
                            </div>
                            <ArrowRightIcon className='icon-color-shades-400 h-40px w-40px flex-shrink-0' />
                        </div>
                    </CustomCard>
                ))}
            </div>
        </GeneralStepBody>
    );
};

export default VerifyIdentity;
